import { Trans } from '@lingui/react/macro'

import { useAppUIModal } from '@/contexts/AppUIModalContext'
import { EPaidProductType } from '@/contexts/PlanContext/type'
import { useSiteSpecificContext } from '@/contexts/SiteSpecificContext'


import { cls } from 'tagged-classnames-free';
import { CssIcon } from '@/components/CssIcon';
interface MenuCardProps {
  icon?: string
  label?: string
  premium?: boolean
  onClick?: () => void
  className?: string
  loading?: boolean
  disabled?: boolean
}

function MenuCard(props: MenuCardProps) {
  const {
    icon,
    label,
    onClick,
    premium,
    className = '',
    loading,
    disabled,
  } = props
  const { plan } = useSiteSpecificContext()
  const { hasActivePlan, creditsProductType } = plan
  const showUpgrade =
    premium && (!hasActivePlan || creditsProductType !== EPaidProductType.PRO)
  const { upgradePlan } = useAppUIModal()

  const handleClick = (e: React.MouseEvent) => {
    if (loading || disabled) {
      e.stopPropagation()
      e.preventDefault()
      return
    }
    if (showUpgrade) {
      e.stopPropagation()
      e.preventDefault()
      upgradePlan.show()
      return
    }
    onClick?.()
  }

  return (
    <div
      className={cls`
        bg-f-bg-elevated group relative cursor-pointer rounded-lg p-[15px] transition-colors
        ${className}
        ${(loading || disabled) && 'pointer-events-none'}
        ${disabled && 'opacity-50'}
      `}
      onClick={handleClick}
    >
      <div
        className={cls`text-f-text-tertiary group-hover:text-f-text relative flex items-center justify-center gap-x-1 text-sm font-semibold`}
      >
        {icon ? (
          <CssIcon
            className={cls`${loading && !disabled ? ' i-svg-spinners--180-ring-with-bg' : icon} size-6`}
          />
        ) : null}
        {label ? (
          <span className={cls`relative flex`}>
            {label}
            {showUpgrade ? (
              <div
                className={cls`flex items-center rounded px-1 text-xs font-semibold`}
              >
                <span
                  className={
                    'font-inter bg-[linear-gradient(90deg,#FF3466_0%,#FF4BF3_47.92%,#8635FF_100%)] bg-clip-text font-bold italic text-transparent'
                  }
                >
                  <Trans>Pro</Trans>
                </span>
              </div>
            ) : null}
          </span>
        ) : null}
      </div>
    </div>
  )
}

export default MenuCard
